import React from "react";
import { Circles, ThreeDots } from "react-loader-spinner";

const FullPageLoader = () => {
  const bootstrapPrimaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--bs-primary")
    .trim();
  return (
    <div style={loaderStyle}>
      <ThreeDots
        visible={true}
        height="80"
        width="80"
        color={bootstrapPrimaryColor}
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

const loaderStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "rgba(255, 255, 255, 0.7)",
  zIndex: 9999,
};

export default FullPageLoader;
